// extracted by mini-css-extract-plugin
export var base = "_4v-0";
export var updateBanner = "_4v-1";